import { fromJS, List, Map } from "immutable";
import axios from "axios";
import cookie from "react-cookies";
import brand from "dan-api/dummy/brand";

// Actions
const TOGGLE_MISSED_CALLS_MODAL = "TOGGLE_MISSED_CALLS_MODAL";
const SET_MISSED_CALLS = "SET_MISSED_CALLS";
const UPDATE_CALL_STATUS = "UPDATE_CALL_STATUS";
const FETCH_MISSED_CALLS_REQUEST = "FETCH_MISSED_CALLS_REQUEST";
const FETCH_MISSED_CALLS_SUCCESS = "FETCH_MISSED_CALLS_SUCCESS";
const FETCH_MISSED_CALLS_FAILURE = "FETCH_MISSED_CALLS_FAILURE";

// Action Creators
export const toggleMissedCallsModal = (isOpen) => ({
  type: TOGGLE_MISSED_CALLS_MODAL,
  payload: isOpen,
});

export const setMissedCalls = (calls) => ({
  type: SET_MISSED_CALLS,
  payload: calls,
});

// Helper function to convert status string to number for API
const getStatusNumber = (statusString) => {
  switch (statusString) {
    case "Cevapsız":
      return 1;
    case "İşlemde":
      return 2;
    case "Tamamlandı":
      return 3;
    default:
      return 1;
  }
};

export const updateCallStatus = (callId, status) => async (dispatch) => {
  try {
    const adminId = cookie.load("AdminId");
    const response = await axios({
      method: "PUT",
      url: `${
        brand.urlSocket
      }api/UnansweredCall/${callId}/status?operatorId=${adminId}`,
      data: getStatusNumber(status),
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (response.data.isStatus) {
      dispatch(syncAndFetchMissedCalls());
    } else {
      console.error("Status update failed:", response.data.responseData);
    }
  } catch (error) {
    console.error("Error updating call status:", error);
  }
};

const fetchMissedCallsRequest = () => ({
  type: FETCH_MISSED_CALLS_REQUEST,
});

const fetchMissedCallsSuccess = (calls) => ({
  type: FETCH_MISSED_CALLS_SUCCESS,
  payload: calls,
});

const fetchMissedCallsFailure = (error) => ({
  type: FETCH_MISSED_CALLS_FAILURE,
  payload: error,
});

// Thunk Actions
export const syncAndFetchMissedCalls = () => async (dispatch) => {
  try {
    dispatch(fetchMissedCallsRequest());

    // First sync the missed calls
    await axios({
      method: "GET",
      url: brand.urlSocket + "api/UnansweredCall/sync-missed-calls",
      dataType: "json",
    });

    // Then fetch the updated list
    const response = await axios({
      method: "GET",
      url: brand.urlSocket + "api/UnansweredCall/list",
      dataType: "json",
    });

    // Parse the responseData string from the wrapper object
    const callsData = JSON.parse(response.data.responseData);

    // Transform the status number to string for UI
    const transformedCalls = callsData.map((call) => ({
      ...call,
      status: getStatusFromNumber(call.Status),
      date: new Date(call.CallDate).toLocaleString("tr-TR", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      }),
      phoneNumber: call.PhoneNumber,
      uniqueid: call.Id,
      operator: call.OperatorName,
    }));

    dispatch(fetchMissedCallsSuccess(transformedCalls));
  } catch (error) {
    console.error("Error fetching missed calls:", error);
    console.log("Response data:", error.response?.data);
    dispatch(fetchMissedCallsFailure(error.message));
  }
};

// Helper function to convert status number to string
const getStatusFromNumber = (statusNumber) => {
  switch (statusNumber) {
    case 1:
      return "Cevapsız";
    case 2:
      return "İşlemde";
    case 3:
      return "Tamamlandı";
    default:
      return "Cevapsız";
  }
};

// Status options for dropdown
const statusOptions = ["Cevapsız", "İşlemde", "Tamamlandı"];

// Function to get status color
const getStatusColor = (status) => {
  switch (status) {
    case "Cevapsız":
      return "#ff0000";
    case "İşlemde":
      return "#4caf50";
    case "Tamamlandı":
      return "#9e9e9e";
    default:
      return "white";
  }
};

// Initial State
const initialState = Map({
  isModalOpen: false,
  missedCalls: List([]),
  loading: false,
  error: null,
});

// Reducer
const missedCallsReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case TOGGLE_MISSED_CALLS_MODAL:
      return state.set("isModalOpen", action.payload);

    case FETCH_MISSED_CALLS_REQUEST:
      return state.set("loading", true).set("error", null);

    case FETCH_MISSED_CALLS_SUCCESS:
      return state
        .set("loading", false)
        .set("error", null)
        .set("missedCalls", List(action.payload));

    case FETCH_MISSED_CALLS_FAILURE:
      return state.set("loading", false).set("error", action.payload);

    case UPDATE_CALL_STATUS: {
      const missedCalls = state.get("missedCalls");
      const callIndex = missedCalls.findIndex(
        (call) => call.uniqueid === action.payload.callId
      );
      if (callIndex === -1) return state;

      axios({
        method: "PUT",
        url: `${brand.urlSocket}api/UnansweredCall/${
          action.payload.callId
        }/status`,
        data: getStatusNumber(action.payload.status),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (response.data.isStatus) {
            dispatch(syncAndFetchMissedCalls());
          } else {
            console.error("Status update failed:", response.data.responseData);
          }
        })
        .catch((error) => {
          console.error("Error updating call status:", error);
        });

      return state;
    }

    default:
      return state;
  }
};

export default missedCallsReducer;
